// contants
import { BREAKPOINTS } from 'styles/base';

// libs
import { styled } from '@nykaa/ui-components';

export const Container = styled.div`
  width: 100%;

  @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding-top: ${({ theme }) => theme.spacing.spacing160};
    margin-top: ${({ theme }) => theme.spacing.spacing160};
    border-top: solid 1px ${({ theme }) => theme.colors.textOutline};
  }
`;

export const NonCollapsible = styled.div`
  width: 100%;

  .nonCollapsibleWidget {
    width: 100%;
    margin-bottom: ${({ theme }) => theme.spacing.spacing80};

    :last-child {
      margin-bottom: 0;
    }
  }
`;

export const ProductInfo = styled.div`
  width: 100%;

  .collapsible {
    :not(:first-child) {
      border-top: 1px solid ${({ theme }) => theme.colors.textOutline};
    }
  }
`;
export const Header = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.titleMedium};

  @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.titleMedium};
  }

  @media screen and (max-width: ${BREAKPOINTS.DESKTOP}px) {
    margin-top: ${({ theme }) => theme.spacing.spacing80};
  }
`;
